module.exports = __webpack_public_path__ + "img/baishuizhai.782c6a64.png";